const state = {
    icons: {
        add: "far fa-plus" ,
        columnChooser: "far fa-line-columns",
        export: "far fa-file-export",
        clear: "far fa-arrow-rotate-left"
    },
};

export default {
state
}